import React from 'react'
import { MapPin, ChevronRight, Building2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const RightAvailableJobs = ({ data }) => {
    let navigate = useNavigate()
    
    if (!data || data.length === 0) {
        return <p className="text-sm text-slate-500 italic">No similar jobs found.</p>
    }

    return (
        <div className='flex flex-col gap-4' >
            {
                [...data].reverse().slice(0, 8).map((obj, index) => (
                    <div 
                        key={index}
                        onClick={() => navigate(`/jobs/${obj.slug || obj.id}`)}
                        className='group cursor-pointer bg-slate-50 hover:bg-blue-50 border border-slate-100 hover:border-blue-200 rounded-xl p-4 transition-all duration-300' 
                    >
                        <div className="flex justify-between items-start mb-2">
                            <h4 className='font-bold text-slate-900 text-[15px] leading-snug group-hover:text-blue-700 transition-colors line-clamp-2 pr-4'>
                                {obj.Title}
                            </h4>
                            <ChevronRight size={18} className="text-slate-400 group-hover:text-blue-600 group-hover:translate-x-1 transition-all flex-shrink-0" />
                        </div>
                        
                        <div className='flex items-center gap-2 text-slate-600 text-xs font-medium mb-3' >
                            <Building2 size={14} className="text-slate-400" />
                            <span className="truncate">{obj.company_inrto || 'Merida HR'}</span>
                        </div>
                        
                        <section className='flex items-center justify-between flex-wrap gap-2 text-xs' >
                            <div className='flex gap-1.5 items-center text-slate-500 bg-white px-2 py-1 rounded-md border border-slate-200' >
                                <MapPin size={12} className="text-slate-400" />
                                <span className="truncate max-w-[120px]">{obj.job_location}</span>
                            </div>
                            
                            <p className="mb-0 text-slate-400 font-medium">
                                {new Date(obj.posted_on).toLocaleString('en-GB', {
                                    day: '2-digit', month: 'short'
                                })}
                            </p>
                        </section>
                    </div>
                ))
            }
        </div>
    )
}

export default RightAvailableJobs